<template src="./date-picker.pug" />

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        label: {
            type: String,
            default: 'Date'
        },
        date: {
            type: String,
            default: null
        },
        minDate: {
            type: String,
            default: null
        },
        maxDate: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        errors: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        menu: false
    }),
    computed: {
        ...mapGetters(['language']),
        mDate: function() {
            return this.maxDate || new Date().toJSON()
        }
    },
    methods: {
        changeDate(date) {
            this.$emit('onDateChange', date)
            this.menu = false
        },
        onCancel(date) {
            this.menu = false
        },
        onClear() {
            this.$nextTick(() => {
                this.$refs.textField.blur()
                this.$emit('onDateChange', null)
            })
        }
    }
}
</script>
